import { safeParseFloat } from '@/core/lib/utils/parse-float'
import { CountryResponse } from '../types/api-responses/country-response'
import { CountryModel } from '../types/models/country.model'

export function countryResolver(country: CountryResponse): CountryModel
export function countryResolver(country: CountryResponse[]): CountryModel[]

export function countryResolver(
  country: CountryResponse | CountryResponse[],
): CountryModel | CountryModel[] {
  if (Array.isArray(country)) {
    return country.map(resolveCountry)
  }
  return resolveCountry(country)
}

function resolveCountry(country: CountryResponse): CountryModel {
  return {
    id: country.id,
    flag: country.country_flag,
    name: country.name,
    latitude: safeParseFloat(country.latitude),
    longitude: safeParseFloat(country.longitude),
  }
}
